export const CENTER_ALIGN_HEADER_CELL_CLS_NAME = "ag-header-cell-text-align";

export const gridColumnMinWidth = 200;
export const gridColumnMaxWidth = 500;
